import { Suspense, type ReactNode } from "react";
import { PersonaLoader } from "@/components/shared/persona-loader";

export function SuspenseWrapper({ children }: { children: ReactNode }) {
  return <Suspense fallback={<PersonaLoader />}>{children}</Suspense>;
}
